<template>
  <div class="extForm">
    <div class="head-box">
      <h4>{{ state == -1 ? '已删除' : '' }}{{ formName }}</h4>
      <div class="c-flex c-flex-item">
        <el-date-picker
          style="width: 240px;"
          v-if="osg.has(path + ',searchDate')"
          v-model="searchDate"
          type="datetimerange"
          :picker-options="date.pickerOptions"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
          class="search-date"
        ></el-date-picker>
        <el-input
          v-if="osg.has(path + ',searchValue')"
          placeholder="请输入要查询的内容"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has(path + ',new')"
          type="primary"
          @click.native="doNew"
          class="c-m-l-10"
        >
          新建
        </el-button>
        <!--  -->
        <el-button
          v-if="osg.has(path + ',buttonSX')"
          type="primary"
          @click.native="doSX('1')"
          class="c-m-l-10"
        >
          星级占比按钮
        </el-button>
        <el-button
          v-if="osg.has(path + ',buttonSX')"
          type="primary"
          @click.native="doSX('2')"
          class="c-m-l-10"
        >
          累计星级占比按钮
        </el-button>
        <el-button
          v-if="osg.has(path + ',downloadQRCodes')"
          type="primary"
          @click.native="
            osg.downloadQRCodes({
              'is:state|integer#and': state == 'all' ? null : 1,
              'gte:createTime|string#and': searchDate[0],
              'lte:createTime|string#and': searchDate[1],
              'regex:name|string#or': searchValue,
              'regex:phone|string#or': searchValue,
              'regex:code|string#or': searchValue,
              'regex:clientName|string#or': searchValue,
              'regex:clientPhone|string#or': searchValue,
              'regex:worker|string#or': searchValue,
              'regex:address|string#or': searchValue,
              'regex:regexParam|string#or': searchValue,
              sortField: 'createTime',
              sortOrder: 'desc',
              extId
            })
          "
          class="c-m-l-10"
        >
          批量下载二维码
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'is:state|integer#and': state == 'all' ? null : 1,
                'gte:createTime|string#and': searchDate[0],
                'lte:createTime|string#and': searchDate[1],
                'regex:name|string#or': searchValue,
                'regex:phone|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:clientName|string#or': searchValue,
                'regex:clientPhone|string#or': searchValue,
                'regex:worker|string#or': searchValue,
                'regex:address|string#or': searchValue,
                'regex:regexParam|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: colName,
                title: formName
              },
              { dynamic: true, preset }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter" v-if="osg.has(path + ',filter')">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          :data="fpi.data"
          ref="table"
          style="width: 100%"
          height="calc(100% - 50px)"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <template v-if="colName == 'income'" slot="count">
              <el-table-column prop="count" label="提现金额" width="120px">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.count / 100 }}
                  </div>
                </template>
              </el-table-column>
            </template>
            <template
              v-if="colName == 'acceptance' || colName == 'acceptance40'"
              slot="serviceProcess"
            >
              <el-table-column prop="serviceProcess" label="服务过程" width="100px">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.serviceProcess && scope.row.serviceProcess.length > 0"
                    class="c_blue c-pointer"
                    @click="serviceProcessClick(scope.row.serviceProcess, 'serviceProcess')"
                  >
                    点击查看
                  </div>
                  <div v-else>无数据</div>
                </template>
              </el-table-column>
            </template>
            <!-- 单独对于施工核查单表格配置 -->
            <template v-if="colName == 'checklist'" slot="inspectionItemList">
              <el-table-column prop="inspectionItemList" label="核查过程" width="100px">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.inspectionItemList && scope.row.inspectionItemList.length > 0"
                    class="c_blue c-pointer"
                    @click="serviceProcessClick(scope.row.inspectionItemList, 'inspectionItemList')"
                  >
                    点击查看
                  </div>
                  <div v-else>无数据</div>
                </template>
              </el-table-column>
            </template>
            <template v-if="colName == 'checklist'" slot="checklistStatus">
              <el-table-column prop="checklistStatus" label="核查状态" width="100px">
                <template slot-scope="scope">
                  <div v-if="!isNaN(scope.row.checklistStatus)">
                    <el-tag :type="serviceProcess.tabType[Number(scope.row.checklistStatus)].type">
                      {{ serviceProcess.tabType[Number(scope.row.checklistStatus)].title }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column
            fixed="right"
            width="100px"
            v-if="
              osg.has(path + ',edit') ||
                osg.has(path + ',remove') ||
                osg.has(path + ',downloadQRCode') ||
                osg.has(path + ',exportDetail') ||
                osg.has(path + ',incomeAudit')
            "
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="
                      scope.row.state == 1 &&
                        scope.row.ioestate == 0 &&
                        osg.has(path + ',incomeAudit')
                    "
                    @click.native="auditClick(scope.row, 1)"
                  >
                    审核通过
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.state == 1 &&
                        scope.row.ioestate == 0 &&
                        osg.has(path + ',incomeAudit')
                    "
                    @click.native="auditClick(scope.row, -1)"
                  >
                    审核不通过
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(path + ',edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(path + ',remove')"
                    @click.native="doRemove(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(path + ',exportDetail')"
                    @click.native="
                      osg.doExport(
                        {
                          'is:state|integer#and': state == 'all' ? null : 1,
                          'regex:name|string#and': searchValue,
                          'gte:createTime|string#and': searchDate[0],
                          'lte:createTime|string#and': searchDate[1],
                          sortField: 'createTime',
                          sortOrder: 'desc',
                          beanName: colName,
                          title: scope.row.name || formName,
                          'fpi-_id': scope.row._id
                        },
                        { dynamic: true, preset, url: 'excel/exportOne.do' }
                      )
                    "
                  >
                    导出此条数据
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(path + ',downloadQRCode')"
                    @click.native="osg.downloadQRCodes({ extId, bizId: scope.row._id })"
                  >
                    下载二维码
                  </el-dropdown-item>
                  <el-popover
                    placement="left"
                    width="400"
                    v-if="osg.has('ServiceAppointments,excelEditor')"
                  >
                    <el-table :data="documentTemplates">
                      <el-table-column
                        property="name"
                        label="文档名称"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column fixed="right" width="140px">
                        <template slot-scope="scopeItem">
                          <el-button
                            size="mini"
                            type="primary"
                            @click.native="
                              osg.excelEditor(
                                colName,
                                scopeItem.row._id,
                                scope.row._id,
                                scope.row.exts && scope.row.exts.workflowDefId
                              )
                            "
                          >
                            使用此模板打印
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-dropdown-item
                      slot="reference"
                      @click.native="
                        osg.getDocumentTemplates(
                          colName,
                          scope.row._id,
                          scope.row.exts && scope.row.exts.workflowDefId
                        )
                      "
                    >
                      打印
                    </el-dropdown-item>
                  </el-popover>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
        <el-dialog :title="formName" :visible.sync="openDetail" :close-on-click-modal="false">
          <c-form
            :formData="formData"
            :fields="extFields"
            :options="options"
            ref="form"
            :upload="upload"
            labelWidth="160px"
            :area="area"
            @changeForm="osg.changeForm"
          ></c-form>
          <div slot="footer">
            <el-button type="primary" @click="doSave">确 定</el-button>
            <el-button @click="doInit">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog
          :title="formName"
          :visible.sync="openDoSXDetail"
          :close-on-click-modal="false"
          :before-close="handleClose"
        >
          <el-form ref="starSalaryRatioFrom" :model="starSalaryRatioFrom" label-width="80px">
            <el-form-item
              label="选择日期"
              prop="starSalaryRatioFrom.dateSX"
              :rules="{
                required: true,
                trigger: ['blur', 'change'],
                message: '年限不能为空'
              }"
            >
              <el-date-picker
                v-model="starSalaryRatioFrom.dateSX"
                type="month"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>

            <!-- <el-form-item
              label="年限"
              prop="yearSX"
              :rules="{
                required: true,
                trigger: ['blur', 'change'],
                message: '年限不能为空'
              }"
            >
              <el-input type="number" v-model="starSalaryRatioFrom.yearSX"></el-input>
            </el-form-item>
            <el-form-item
              label="月份"
              prop="monthSX"
              :rules="{
                required: true,
                trigger: ['blur', 'change'],
                message: '年限不能为空'
              }"
            >
              <el-input type="number" v-model="starSalaryRatioFrom.monthSX"></el-input>
            </el-form-item> -->
          </el-form>
          <div slot="footer">
            <el-button type="primary" @click="doButtonSX()">确 定</el-button>
            <el-button @click="doInit">取 消</el-button>
          </div>
        </el-dialog>

        <!-- 施工验收单服务过程 -->
        <el-dialog
          :title="serviceProcess.title"
          :visible.sync="serviceProcess.show"
          :close-on-click-modal="false"
          class="serviceProcess"
          width="55%"
        >
          <div v-for="(part, i) in serviceProcess.data" :key="i" class="part">
            <div class="c-font-bold">验收部位：{{ part.constructionLocation }}</div>
            <div class="c-font-bold" v-if="part.partDescription">
              部位描述：{{ part.partDescription }}
            </div>
            <div v-if="part.procedures && part.procedures.length > 0">
              <div v-for="(procedure, j) in part.procedures" :key="j" class="c-m-t-20">
                <div>服务内容：{{ procedure.content }}</div>
                <div v-if="procedure.desc" class="c-flex">
                  <div style="white-space: nowrap;">服务描述：</div>
                  <div>{{ procedure.desc }}</div>
                </div>
                <div
                  v-if="
                    procedure.processStepDefinitions && procedure.processStepDefinitions.length > 0
                  "
                  class="c-m-l-20 c-m-b-10"
                >
                  <div v-for="(step, k) in procedure.processStepDefinitions" :key="k">
                    <div class="c-m-t-10 c-m-b-10">步骤{{ k + 1 }}：{{ step.name }}</div>
                    <div v-if="step.urls && step.urls.length > 0" class="c-m-t-10 c-m-b-10 step">
                      <el-image
                        v-for="(urlObj, l) in step.urls"
                        :key="l"
                        style="width: 100px; height: 100px;border-radius:5px;"
                        :src="urlObj.url"
                        fit="cover"
                        :preview-src-list="step.urls.map(item => item.url)"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 核查单 详情 -->
          <div class="part" v-if="serviceProcess.inspectionItemList.length > 0">
            <div v-for="(item, index) in serviceProcess.inspectionItemList" :key="index">
              <el-row :gutter="20" style="margin: 10px 0px;">
                <el-col :span="1">
                  <div class="grid-content bg-purple" style="text-align: center;">
                    {{ index + 1 }}、
                  </div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple">{{ item.name }}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple" style="text-align: center;">
                    <el-tag
                      :type="
                        item.validation.check === 1
                          ? 'success'
                          : item.validation.check === null
                          ? 'info'
                          : 'danger'
                      "
                    >
                      {{
                        item.validation.check === 1
                          ? '通过'
                          : item.validation.check === null
                          ? '待核查'
                          : '不通过'
                      }}
                    </el-tag>
                  </div>
                </el-col>
              </el-row>
              <template v-if="item.validation.check === 0">
                <el-row
                  v-if="item.validation.beforeFileList.length > 0"
                  :gutter="20"
                  type="flex"
                  align="middle"
                  style="margin: 10px 0px;"
                >
                  <el-col :span="1">
                    <div class="grid-content bg-purple">&nbsp;</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <span>不合格图片：</span>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <el-image
                      v-for="i in item.validation.beforeFileList"
                      :key="i"
                      style="width: 100px; height: 100px;border-radius:5px;"
                      :src="i.url"
                      class="c-m-l-5"
                      :preview-src-list="item.validation.beforeFileList.map(K => K.url)"
                    ></el-image>
                  </el-col>
                </el-row>
                <el-row
                  v-if="item.validation.reason"
                  :gutter="20"
                  type="flex"
                  align="middle"
                  style="margin: 10px 0px;"
                >
                  <el-col :span="1">
                    <div class="grid-content bg-purple">&nbsp;</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <span>不合格原因：</span>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div class="grid-content bg-purple">{{ item.validation.reason }}</div>
                  </el-col>
                </el-row>
                <el-row
                  v-if="item.validation.norm"
                  :gutter="20"
                  type="flex"
                  align="middle"
                  style="margin: 10px 0px;"
                >
                  <el-col :span="1">
                    <div class="grid-content bg-purple">&nbsp;</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <span>整改要求：</span>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div class="grid-content bg-purple">{{ item.validation.norm }}</div>
                  </el-col>
                </el-row>
                <el-row
                  v-if="item.validation.rectifyTime"
                  :gutter="20"
                  type="flex"
                  align="middle"
                  style="margin: 10px 0px;"
                >
                  <el-col :span="1">
                    <div class="grid-content bg-purple">&nbsp;</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <span>整改时间：</span>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div class="grid-content bg-purple">{{ item.validation.rectifyTime }}</div>
                  </el-col>
                </el-row>
                <el-row
                  v-if="item.validation.afterfileList.length > 0"
                  :gutter="20"
                  type="flex"
                  align="middle"
                  style="margin: 10px 0px;"
                >
                  <el-col :span="1">
                    <div class="grid-content bg-purple">&nbsp;</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <span>整改后图片：</span>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <el-image
                      v-for="i in item.validation.afterfileList"
                      :key="i"
                      style="width: 100px; height: 100px;border-radius:5px;"
                      :src="i.url"
                      class="c-m-l-5"
                      :preview-src-list="item.validation.afterfileList.map(K => K.url)"
                    ></el-image>
                  </el-col>
                </el-row>
                <el-row
                  v-if="item.validation.reformCheck !== null"
                  :gutter="20"
                  type="flex"
                  align="middle"
                  style="margin: 10px 0px;"
                >
                  <el-col :span="1">
                    <div class="grid-content bg-purple">&nbsp;</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="grid-content bg-purple">
                      <span>整改后结果：</span>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <el-tag :type="item.validation.reformCheck ? 'success' : 'danger'">
                      {{ item.validation.reformCheck ? '整改后通过' : '整改后仍不通过' }}
                    </el-tag>
                  </el-col>
                </el-row>
              </template>
            </div>
          </div>

          <div slot="footer">
            <el-button type="primary" @click="serviceProcess.show = false">关 闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'extForm',
  inject: ['viewReload'], //注入nav里的viewReload方法
  data() {
    window.$this = this;
    return {
      name: '', //过滤器用
      refresh: true,
      path: '', //路径-读取角色权限
      basePath: '', //接口基础路径
      colName: '',
      preset: '1',
      extId: null,
      formDefId: null,
      formName: null,
      searchValue: '',
      searchDate: [],
      fpi: {},
      extFields: [],
      openDetail: false,
      options: {},
      formData: {},
      state: '',
      rules: this.$util.rules,
      // 上传
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      openDoSXDetail: false,
      starSalaryRatioFrom: {
        yearSX: '',
        monthSX: '',
        SXButtonType: '',
        dateSX: ''
      },
      ioe: '', // 收益明细管理参数过滤
      // 施工验收单服务过程
      serviceProcess: {
        title: '', //弹出的表格 标题名称
        show: false,
        data: [],
        inspectionItemList: [],
        //核查单的状态
        tabType: [
          { title: '待核查', type: 'info' },
          { title: '部分通过', type: 'warning' },
          { title: '整改后通过', type: '' },
          { title: '全部通过', type: 'success' },
          { title: '不通过', type: 'danger' }
        ]
      }
    };
  },
  mounted() {
    this.path = decodeURIComponent(
      (window.location.pathname + window.location.search).substring(1)
    );
    this.dataKey = this.osg.param('dataKey');
    this.name = this.osg.param('colName');
    this.colName = this.osg.param('colName');
    this.formDefId = this.osg.param('extId');
    this.state = this.osg.param('state');
    this.basePath = this.osg.param('basePath');
    // 收益明细管理参数过滤
    this.ioe = this.osg.param('ioe');
    this.doInit();
    this.getExtByColName();
    this.osg.getFields(this.colName, () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {};
      this.openDoSXDetail = false;
      this.starSalaryRatioFrom.dateSX = '';
      this.starSalaryRatioFrom.SXButtonType = '';
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getExtByColName() {
      this.osg.ajax('biz/ext/queryByColName/' + this.colName + '.do', {}, res => {
        this.formName = res.entity.title;
        this.preset = res.entity.templateType == 'TT1' ? '1' : '0';
        this.extId = res.entity._id;
      });
    },
    getData() {
      this.searchDate = this.searchDate || [];
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'is:state|integer#and': this.state == 'all' ? null : this.state || 1,
        'is:ioe|integer#and': this.ioe || null,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:clientName|string#or': this.searchValue,
        'regex:clientPhone|string#or': this.searchValue,
        'regex:worker|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'regex:regexParam|string#or': this.searchValue,
        'regex:activityId|string#or': this.searchValue,
        'gte:createTime|string#and': this.searchDate[0],
        'lte:createTime|string#and': this.searchDate[1],
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // 勘察渗漏原因、施工验收注意事项 按部位顺序和原因顺序排序
      if (this.colName == 'leakageCause') {
        params.sortField = 'partOrder,leakageCauseOrder';
        params.sortOrder = 'asc';
      }
      if (this.colName == 'noteItems') {
        params.sortField = 'partOrder,order';
        params.sortOrder = 'asc';
      }
      // 巡检SOP管理列表按sop顺序排序
      if (this.colName == 'inspectionSOP') {
        params.sortField = 'sopOrder';
        params.sortOrder = 'asc';
      }
      // 巡检部位原因管理列表按部位顺序排序
      if (this.colName == 'inspectionCause' || this.colName == 'check') {
        params.sortField = 'partOrder';
        params.sortOrder = 'asc';
      }
      if (this.osg.has(this.path + ',filter')) {
        window.$that.getParams(params);
      }
      this.osg.setFpi(params);
      let url = this.basePath
        ? `${this.basePath}/query.do`
        : this.formDefId
        ? 'biz/extForm/query/' + this.formDefId + '.do'
        : 'biz/extForm/queryByColName/' + this.colName + '.do';
      // 如果当前页面为核查单页面 请求接口为query
      if (this.colName == 'checklist') {
        url = 'basic/checklist/query.do';
      }
      this.osg.ajax(url, params, res => {
        res.data = res.data.map(item => {
          item.exts = item.exts || {};
          return item;
        });
        // 渲染字段防止报错
        this.$util.renderExtFormFields(this.extFields, res.data);
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.formData.state = 1; // 默认状态1
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveFormatExtField(this.extFields, params);
        let url = this.basePath
          ? `${this.basePath}/upsert.do`
          : 'biz/extForm/upsert/' + this.extId + '.do';
        this.osg.ajax(
          url,
          this.basePath
            ? this.dataKey
              ? { [this.dataKey]: JSON.stringify(params) }
              : params
            : { dataStr: JSON.stringify(params) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    doEnable(row) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(this.basePath + '/enable.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('已启用');
        });
      });
    },
    doDisable(row) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(this.basePath + '/disable.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('已启用');
        });
      });
    },
    doRemove(row) {
      this.osg.confirm('是否确认删除？', () => {
        let url = this.basePath
          ? `${this.basePath}/remove.do`
          : `biz/extForm/remove/${this.extId}.do`;
        let params = this.basePath
          ? { id: row._id }
          : {
              formDataId: row._id
            };
        this.osg.ajax(url, params, () => {
          this.getData();
          this.osg.toast('删除成功');
        });
      });
    },
    doSX(val) {
      // val  ：1星级占比  2累计星级占比
      this.SXButtonType = val;
      this.openDoSXDetail = true;
    },
    handleClose() {
      this.doInit();
    },
    doButtonSX() {
      if (!this.starSalaryRatioFrom.dateSX) {
        this.osg.toast('请选择年月', 'warning');
        return;
      }
      console.log(this.starSalaryRatioFrom.dateSX, '---starSalaryRatioFrom.dateSX');
      let params = {
        year: this.starSalaryRatioFrom.dateSX.getFullYear() || '',
        month: this.starSalaryRatioFrom.dateSX.getMonth() + 1 || ''
      };
      console.log(params, '----params');
      if (this.SXButtonType == '1') {
        this.osg.ajax(
          '/biz/settle/contractSXStarSalaryRatio.do',
          params,
          () => {
            this.openDoSXDetail = false;
            this.osg.toast('操作成功！');
            this.getData();
            this.starSalaryRatioFrom.yearSX = '';
            this.starSalaryRatioFrom.monthSX = '';
          },
          {
            noload: true
          }
        );
      }
      if (this.SXButtonType == '2') {
        this.osg.ajax(
          '/biz/settle/contractSXAccumulateSalaryRatio.do',
          params,
          () => {
            this.openDoSXDetail = false;
            this.osg.toast('操作成功！');
            this.getData();
            this.starSalaryRatioFrom.yearSX = '';
            this.starSalaryRatioFrom.monthSX = '';
          },
          {
            noload: true
          }
        );
      }
    },
    auditClick(row, val) {
      if (val == 1) {
        this.osg.confirm('请确认是否通过审核？', () => {
          this.osg.ajax('/basic/income/audit.do', { id: row._id }, () => {
            this.getData();
            this.osg.toast('审核通过');
          });
        });
      }
      if (val == -1) {
        this.osg.confirm('请确认是否不通过审核？', () => {
          this.osg.ajax('/basic/income/refuse.do', { id: row._id }, () => {
            this.getData();
            this.osg.toast('审核不通过');
          });
        });
      }
    },
    // 查看施工验收单服务过程
    serviceProcessClick(data, type) {
      switch (type) {
        case 'serviceProcess':
          this.serviceProcess.data = data;
          this.serviceProcess.title = '服务流程';
          break;
        case 'inspectionItemList':
          this.serviceProcess.inspectionItemList = data;
          this.serviceProcess.title = '核查详情';
          break;
        default:
      }
      this.serviceProcess.show = true;
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      this.viewReload();
    }
  }
};
</script>
<style lang="scss">
.extForm {
  // 施工验收单服务过程
  .serviceProcess {
    .el-dialog__body {
      padding: 15px !important;
      .part {
        margin-bottom: 15px;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        padding: 10px;
        &:last-child {
          margin-bottom: 0;
        }
        .step {
          display: flex;
          flex-wrap: wrap;
          row-gap: 10px;
          column-gap: 10px;
        }
      }
    }
  }
}
</style>
